<ion-chip
  mode="ios"
  color="transparent"
  [outline]="false"
  class="getm-price-display"
>
  <ng-container *ngIf="discount && discount > 0">
    <ion-label [color]="discountColor" class="discount-label">
      {{ price | currency : undefined : 'symbol' : '1.2-2' }}
      
    </ion-label>
  </ng-container>

  <ng-container *ngIf="discount && discount > 0">
    <ion-label [color]="priceColor" class="price-label">
      {{ discount | currency : undefined : 'symbol' : '1.2-2' }}
    </ion-label>
  </ng-container>

  <ng-container *ngIf="!discount || discount === 0">
    <ion-label [color]="priceColor" class="price-label">
      {{ price | currency : undefined : 'symbol' : '1.2-2' }}
    </ion-label>
  </ng-container>
</ion-chip>
